<div [class.reply]="isReply" class="w-100 chatPanel">
    <div *ngIf="!initialCommentData && currentUser" [appUserAvatar]="currentUser" class="miniInitial bg-primary m-15"
         mat-card-avatar>
        <span class="primary-text">{{ currentUser?.username | slice: 0 : 1 | titlecase }}</span>
    </div>
    <div class="contentColumn">
        <!--            <mat-form-field appearance="outline" class="whiteField noBottomPadding" color="primary" [class.closedState]="!isOpenState">-->
        <!--                <textarea matInput maxlength="400" [formControl]="comment" [placeholder]="placeholder" [rows]="isOpenState ? 3 : 1" (focus)="setState(true)"></textarea>-->
        <!--            </mat-form-field>-->
        <div class="d-flex flex-row w-100 gap-10 mobileReverseColumn">
            <div class="flex-auto w-100">
                <mat-form-field [class.closedState]="!isOpenState" appearance="outline" class="whiteField w-100"
                                color="primary">
                    <mat-label>Comment</mat-label>
                    <textarea #replyField (focus)="commentFocus(replyField)" [formControl]="comment"
                              [placeholder]="placeholder"
                              [rows]="isOpenState ? 4 : 1"
                              class="textAreaResize"
                              matInput required></textarea>
                </mat-form-field>
                <mat-checkbox *ngIf="isOpenState && hasCommunityRole(['member'])" [(ngModel)]="is_anonymous">Comment
                    Anonymously
                </mat-checkbox>
            </div>
            <div *ngIf="isOpenState && post?.emoji_enabled && this.selectedCommunity?.emoji_enabled"
                 class="flex-col flex-space-between">
                <app-emoji-menu [formControl]="comment" [htmlInput]="replyField" matSuffix
                                ngDefaultControl></app-emoji-menu>
            </div>

        </div>
        <div class="flex-row flex-space-between gap-10 mt-10 mobileCol">
            <app-attachments
                    (isValid)="attachmentsValidEmitter($event)"
                    (submitField)="getAttachmentField($event)"
                    [attachmentOptions]="['text', 'image', 'video', 'audio', 'videoLink', 'screenRecording', 'url','doc', 'gif', 'survey_url', 'poll', 'heatmap']"
                    [class.addMargin]="post?.emoji_enabled"
                    [class.no-visible]="!isOpenState"
                    [comment]="true"
                    [initialAttachment]="initialCommentDataAttachment"
                    [reply]="true"
                    [small]="true"
                    class="commentAttachment"
            ></app-attachments>
            <div *ngIf="isOpenState" class="flex-row flex-end gap-10">
                <button (click)="reset()" color="warn" mat-raised-button>
                    Cancel
                </button>
                <div [matTooltip]="(!attachment && !comment.value) || !attachmentsValid? 'Message or attachment required' :null">
                    <button (click)="!initialCommentData ? submitComment() : patchComment()"
                            (mouseenter)="validate(comment)"
                            [disabled]="(!attachment && !comment.value) || !attachmentsValid"
                            color="accent"
                            mat-raised-button>
                        <ng-container *ngIf="initialCommentData">Update comment</ng-container>
                        <ng-container *ngIf="!isReply && !initialCommentData">Submit</ng-container>
                        <ng-container *ngIf="isReply && !initialCommentData">Reply</ng-container>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
